import { Component } from '@angular/core';

@Component({
  selector: 'app-404',
  template: `
    <article class="animated slideInRight">
      <div>the page you are looking for is not here :-) .</div>
    </article>
  `
})
export class PageNotFoundComponent { }
